import { requestJson } from "../lib/api";

export function getAdminTnuaQrs() {
  return requestJson("/api/tnua-qr");
}

export function redeemTnuaQr(payload) {
  return requestJson("/api/tnua-qr/redeem", {
    method: "POST",
    body: payload,
  });
}
